var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0H13C11.8053 0 10.7329 0.523756 10 1.35418C9.26706 0.523756 8.19469 0 7 0H2H0V2V14C0 15.1046 0.89543 16 2 16H7C8.10457 16 9 16.8954 9 18H11C11 16.8954 11.8954 16 13 16H18C19.1046 16 20 15.1046 20 14V11H18V14H13C12.2714 14 11.5883 14.1948 11 14.5351V4C11 2.89543 11.8954 2 13 2H15V0ZM2 2V14H7C7.72857 14 8.41165 14.1948 9 14.5351V4C9 2.89543 8.10457 2 7 2H2ZM18 9V4H20V9H18ZM19 0C18.4477 0 18 0.447715 18 1C18 1.55228 18.4477 2 19 2C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e57222298e5d268cd39ccc0d01c647d8.svg";
export { ForwardRef as ReactComponent };